import React, { useState, ChangeEvent } from 'react';
import { Box, Button, Chip, Container, IconButton, Stack, Typography, alpha } from '@mui/material';
import { OpenInNewRounded } from '@mui/icons-material';

interface FileBoxProps { 
  label: string,  
  file?: string, 
  onUpload?: (fileName: string, data: string) => Promise<boolean>,
  canUpload?: boolean,
}
export const FileBox = (props: FileBoxProps) => { 
  const { label, file, onUpload, canUpload } = props;
  const [data, setData] = useState('');
  const [fileName, setFileName] = useState(file ?? 'No file uploaded...');
  const [enable, setEnable] = useState(false);

  const handleInputOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFileName(event.target.files[0].name);
      setEnable(true);

      const fileReader = new FileReader();
      fileReader.readAsDataURL(event.target.files[0]);
      fileReader.onload = (e) => {
        if (e.target && e.target.result && typeof e.target.result === 'string') {
          setData(e.target.result);
        }
      };
    }
  };

  const handleUploadOnClick = () => {
    if (canUpload) {
      onUpload && onUpload(fileName, data).then((s) => {
        if (s) {
          setData('');
          setFileName(file ?? 'No file uploaded...');
          setEnable(false);
        }
      });
    }
  };

  return (
    <Stack 
      direction="row"
      spacing={1}
      sx={{ 
        p: 2,
        py: 0.5,
        pr: 0.5,
        borderRadius: 1,
        alignItems: 'center',
        backgroundColor: theme => alpha(theme.palette.primary.main, 0.1),
        "&:hover": {
          backgroundColor: theme => alpha(theme.palette.primary.main, 0.15)
        },
      }}
    >
      <Typography variant="button" whiteSpace="nowrap">{label}</Typography>
      <Box component="div" sx={{ display: 'flex', flexGrow: 1, mx: 2, alignItems: 'center', overflow: 'hidden' }}>
        <Typography variant="caption" textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
          {file ? enable ? fileName : file : fileName}
        </Typography>
      </Box>
      <IconButton LinkComponent="a" size="small" href={file ?? ''} target="_blank" disabled={file === undefined}>
        <OpenInNewRounded />
      </IconButton>
      {canUpload == true && (
        <Button component="label">
          Browse
          <input hidden type="file" onChange={handleInputOnChange} />
        </Button>
      )}
      {canUpload == true && (
        <Button color="secondary" disabled={!enable} onClick={handleUploadOnClick}>
          Upload
        </Button>
      )}
    </Stack>
  )
};